<template>
  <v-container fluid fill-height>
    <v-layout NAalign-center justify-center>
        <v-flex xs12 sm8 md4>
        <v-card class="mt-4">
            <v-toolbar classa="hidden-sm-and-down" dark color="secondary">
							<v-toolbar-title>
                <v-icon>input</v-icon>
                Sign In
              </v-toolbar-title>
							<v-spacer></v-spacer>           
            </v-toolbar>
            <v-card-text>
            <v-form ref="form">
							<v-text-field
								:rules="[rules.required, rules.email]"
								prepend-icon="person"
								v-model="email"
                autofocus
								name="email"
								label="Email"
								type="text"></v-text-field>
							<v-text-field
                @keydown.enter="loginHandler"
								:rules="[rules.required, rules.min]"
								prepend-icon="lock"
								v-model="password"
								name="password"
								label="Password"
								id="password"
								type="password"></v-text-field>
            </v-form>
            <v-alert
              :value="hasError"
              type="error">
              {{ errorText }}
            </v-alert>        
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="loginHandler">Login</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              Not registered? <a href="/sign-up" class="ml-2">Sign up!</a>
            </v-card-actions>
        </v-card>
        </v-flex>
    </v-layout>     
          
  </v-container>
</template>

<script>
  export default {
		data () {
			return {
				email: '',
				login: '',
				password: '',
        rules: {
          required: value => !!value || '', //'Required.',
          min: v => v.length >= 4 || '', //'Min 8 characters',
          email: v => /.+@.+/.test(v) || 'E-mail must be valid'
        },
        hasError: false,
        errorText: ''
			}
    },
    methods: {
      loginHandler () {
        if (!this.$refs.form.validate()) {
          // return
        }        
        this.hasError = false
        this.$httpApi
          .post('/authentication', {
            strategy: 'local',
            email: this.email,
            password: this.password
          })
          .then((result) => {
            localStorage.jwt = result.data.accessToken
            // this.$httpApi.defaults.headers.common['Authorization'] = result.data.accessToken; // does not work
            console.log("loginHandler success", result)
            this.$router.push({ name: 'user-dashboard' })             
          })
          .catch(err => {
            console.error("loginHandler ERROR", err)
            this.hasError = true
            this.errorText = 'Signin failed! Incorrect email/password combination.'
          })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>